import Box from "@memorang/ui/src/components/Box";
import { Text } from "react-native-paper";

const OnboardingHeader = ({
	title,
	description,
	center = false,
}: {
	title: string;
	description: string;
	center?: boolean;
}) => {
	return (
		<Box gap={8}>
			<Text
				variant="headlineLarge"
				style={{ textAlign: center ? "center" : "left" }}
			>
				{title}
			</Text>
			<Text
				variant="bodyLarge"
				style={{ textAlign: center ? "center" : "left" }}
			>
				{description}
			</Text>
		</Box>
	);
};

export default OnboardingHeader;
